import { useContext, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GetGoogleToken } from '../components/GenerateGoogleToken';
import { Column } from '../components/forms/Column';
import { AppContext } from '../AppContext';
import { useLocation } from 'react-router-dom';
import { CreateEmailAccount, CreateEmailAccountResult } from 'bloggers-backend/lib/email/domain/events';

export default function CreateEmailAccountPage() {
    const header = 'Create a new account'
    const {notificationsService} = useContext(AppContext);
    const location = useLocation();
    const error = new URLSearchParams(location.search).get('error');

    useEffect(() => {
        if (error) {
          notificationsService.notify({
            severity: "error",
            message: error
          })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    return (
        <Column>
            <h2>{header}</h2>
            <GetGoogleToken/>
            <CreateTestingAccount/>
        </Column>
    )
};

const CreateTestingAccount = () => {
    const {client, notificationsService} = useContext(AppContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    async function createTestingAccount() {
        const email = window.prompt('Email for the testing account');
        if (!email) {
            return;
        }

        setLoading(true);
        const result = await client<CreateEmailAccount, CreateEmailAccountResult>({
            event: 'createEmailAccount',
            data: { email, service: 'testing', auth: { token: 'testing' } } as any,
        });

        if (result.success) {
            navigate(`/email-accounts/${result.value.id}`);
        } else {
            notificationsService.notify({
                severity: 'error',
                message: JSON.stringify(result.errors),
            });
        }

        setLoading(false);
    }

    return (
        <Button
            disabled={loading}
            variant="contained"
            onClick={createTestingAccount}
        >Testing</Button>
    );
};
